import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

/**
 * Warning shown under the permission switches, such as for the owner account or a system user manager.
 */
function PermissionAlert({ messageId }) {
  return (
    <Row className="permissionAlert justify-content-left">
      <Col md="1">
        <i className="warning-permission-icon ps-2 pe-0" />
      </Col>
      <Col md="11">
        <FormattedMessage id={messageId} />
      </Col>
    </Row>
  )
}

PermissionAlert.propTypes = {
  /** FormattedMessage id of the warning */
  messageId: PropTypes.string.isRequired,
}

export default React.memo(PermissionAlert)
